/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckListEntry } from './grundstueckListEntry';
import { RechtMasterListEntry } from './rechtMasterListEntry';


export interface PersonGbRolleMitRecht { 
    rolle?: PersonGbRolleMitRecht.RolleEnum;
    eigentumsform?: PersonGbRolleMitRecht.EigentumsformEnum;
    eigentum?: GrundstueckListEntry;
    beziehungZuRecht?: RechtMasterListEntry;
    glaeubigerrolle?: PersonGbRolleMitRecht.GlaeubigerrolleEnum;
}
export namespace PersonGbRolleMitRecht {
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER' | 'SCHULDNER';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGEBERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGER: 'GLAEUBIGER' as RolleEnum,
        SCHULDNER: 'SCHULDNER' as RolleEnum
    };
    export type EigentumsformEnum = 'ALLEINEIGENTUM' | 'MITEIGENTUM' | 'GESAMTEIGENTUM';
    export const EigentumsformEnum = {
        ALLEINEIGENTUM: 'ALLEINEIGENTUM' as EigentumsformEnum,
        MITEIGENTUM: 'MITEIGENTUM' as EigentumsformEnum,
        GESAMTEIGENTUM: 'GESAMTEIGENTUM' as EigentumsformEnum
    };
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
}


